import img1 from "../assets/blog/frontend.jpg";
import img2 from "../assets/blog/coding.png";
import img3 from "../assets/blog/git.jpg"
import img4 from "../assets/blog/how to code faster.svg"
import aiTrap from "../assets/blog/ai Trap.jpg"
import dev_kashmir from "../assets/blog/kashmirDev.jpg"
import kashmir_marriage from "../assets/blog/8862 (1).jpg"
const blogData= [
  {
    title: "Front-end projects",
    description: "Master Front-end development with these projects 🧑‍💻",
    imgurl:img1,
    link:"https://muazim.substack.com/p/front-end-projects-for-beginners",
    toShow:false,
  },
  {
    title:"Accelerate Your Coding",
    description:"Practical Steps to Accelerate Your Coding Journey 🚀",
    imgurl:img2,
    link:"https://muazim.substack.com/p/accelerate-your-coding-journey",
     toShow:false,
  },
  {
    title:"Master Git and Github",
    description:"Follow these guidelines to master git & github 🧑‍💻",
    imgurl:img3,
    link:"https://muazim.substack.com/p/master-git-and-github",
     toShow:false,
  },
  {
    title:"How To Code Faster",
    description:"Here are some simple tips to help you zip through your projects like a pro🚀",
    imgurl:img4,
    link:"https://muazim.substack.com/p/how-to-code-faster-as-a-software",
     toShow:true,
  },
  {
    title:"Influencers vs Ai",
    description:"How Influencers Are Making People Scared of AI",
    imgurl:aiTrap,
    link:"https://muazim.substack.com/p/how-influencers-are-making-people",
    toShow:true
  },
  {
    title:"Kashmir’s Dev Wave",
    description:"The Rise and wave of Developers in Kashmir valley",
    imgurl:dev_kashmir,
    link:"https://muazim.substack.com/p/the-rise-of-developers-in-kashmir",
    toShow:true
  },
  {
    title:"Shaadi After Selection",
    description:"The Government Job Obsession in Kashmiri Marriages",
    imgurl:kashmir_marriage,
    link:"https://muazim.substack.com/p/shaadi-after-selection-the-government",
    toShow:true,
  }
  ];

export default blogData;
